import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { i18n } from '@/i18n/config';
import { Link } from '@/i18n/navigation';

export default function LocaleSwitcher({ locale }: { locale: string }) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="-ml-2 inline-grid grid-cols-1">
          <div
            aria-label="Language"
            className="col-start-1 row-start-1 w-full cursor-pointer appearance-none rounded-md bg-white py-0.5 pr-7 pl-2 text-left text-base font-medium text-gray-400 hover:text-gray-500 hover:shadow-md focus:outline-2 focus:-outline-offset-1 focus:outline-white sm:text-sm/6"
          >
            <span aria-hidden="true">{i18n.locales.find((l) => l.id === locale)?.icon}</span>
            <span className="sr-only">{i18n.locales.find((l) => l.id === locale)?.title}</span>
          </div>
          <ChevronDownIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 mr-1 size-5 self-center justify-self-end"
          />
        </MenuButton>
      </div>

      <MenuItems
        transition
        anchor="bottom start"
        className="absolute right-0 z-50 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
      >
        <div className="py-1">
          {i18n.locales.map((locale, i) => (
            <div key={i} className="group">
              <MenuItem>
                <Link
                  href="/"
                  locale={locale.id}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
                >
                  {locale.icon} {locale.title} ({locale.country})
                </Link>
              </MenuItem>
            </div>
          ))}
        </div>
      </MenuItems>
    </Menu>
  );
}
